import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { TournamentParticipantList } from "@nestcoinco/hyper-api-gateway-api-client";

import { QUERY_KEYS } from "../constants";
import {
  type GetParticipantsParamsType,
  handleGetTournamentParticipants,
} from "../../api-clients/tournamentsClient";

type UseParticipantsParams = GetParticipantsParamsType & {
  enabled?: boolean;
  refetchInterval?: number;
  retry?: number;
};

function useTournamentParticipantsQuery({
  tournamentId,
  limit,
  page,
  refetchInterval,
  userCompleted,
  retry,
  enabled = true,
}: UseParticipantsParams): UseQueryResult<TournamentParticipantList, Error> {
  const query = useQuery({
    queryKey: [QUERY_KEYS.TOURNAMENT.TOURNAMENT_PARTICIPANTS, tournamentId],
    queryFn: () =>
      handleGetTournamentParticipants({
        tournamentId,
        page,
        limit,
        userCompleted,
      }),
    enabled: !!tournamentId && enabled,
    refetchInterval,
    retry,
  });

  return query;
}

export default useTournamentParticipantsQuery;
